"use client";

import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";

type BeforeInstallPromptEvent = Event & {
  prompt: () => Promise<void>;
  userChoice: Promise<{ outcome: "accepted" | "dismissed" }>;
};

export function InstallPwaPrompt() {
  const [evt, setEvt] = useState<BeforeInstallPromptEvent | null>(null);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onBip = (e: Event) => {
      e.preventDefault();
      setEvt(e as BeforeInstallPromptEvent);
    };
    window.addEventListener("beforeinstallprompt", onBip);

    return () => window.removeEventListener("beforeinstallprompt", onBip);
  }, []);

  if (!evt || dismissed) {
    return null;
  }

  return (
    <div className="fixed bottom-4 left-4 right-4 z-50 flex flex-col gap-3 rounded-lg border bg-card p-3 pb-safe shadow-lg sm:flex-row sm:items-center sm:justify-between md:left-auto md:right-4 md:max-w-md">
      <p className="text-sm text-muted-foreground">Install for quick home-screen access.</p>
      <div className="flex shrink-0 gap-2">
        <Button type="button" size="sm" variant="secondary" onClick={() => setDismissed(true)}>
          Dismiss
        </Button>
        <Button
          type="button"
          size="sm"
          onClick={async () => {
            await evt.prompt();
            await evt.userChoice;
            setDismissed(true);
          }}
        >
          Install
        </Button>
      </div>
    </div>
  );
}
